import React, { ComponentProps } from "react";

import { showDialogAsync } from "../../dialog-queue";
import { ProductValidation } from "../../product-validation";

import { ProductWarningsDialog } from "./product-warnings-dialog";

const ProductWarningsDialogContainer = ({
	messages,
	onOk,
	...dialogProps
}: {
	onOk: () => void;
} & ComponentProps<typeof ProductWarningsDialog> &
	Pick<ComponentProps<typeof ProductValidation>, "messages">) => {
	return (
		<ProductWarningsDialog onOk={onOk} {...dialogProps}>
			<ProductValidation messages={messages} onClick={onOk} showDetails />
		</ProductWarningsDialog>
	);
};

export function showProductWarningsDialogAsync(messages: eXpress.core.ValidationMessages[]) {
	return showDialogAsync<boolean>(({ resolve }, { isOpen }) => (
		<ProductWarningsDialogContainer
			onOk={() => resolve(true)}
			messages={messages}
			isOpen={isOpen}
		/>
	));
}
